import type { PositionStatusReason } from '@/api/spec';
import type { PositionCore, PositionStatus } from './types';

export type PNLEntry = PositionCore & {
  dateTimestamp: number;
  /** Absent for events that settle nothing (opens, increases, collateral changes). */
  exitPrice?: number;
  /** Absent when no size moved or the settle price is unknown. */
  notionalValue?: number;
  margin: number;
  pnl: number;
  roe: number;
  funding: number;
  /** Cost for PnL math (pro-rata entry share + close fee on reducing events). Not for display — see `collectedFee`. */
  fee: number;
  /** Fee the event itself charged: entry fee on open/increase/invert, `cfee` on close/decrease; absent when none. */
  collectedFee?: number;
  /** Amount the insurance fund paid to cover a settlement shortfall (`Position.pay`). */
  insurancePayment?: number;
  status: PositionStatus;
  /** Raw API reason identifying the event kind; drives the Event column and liquidation chip/filter. */
  statusReason?: PositionStatusReason;
};

/** True when a position-history row realized funding — the rows the Funding History tab shows. */
export const isFundingEvent = (entry: PNLEntry): boolean => entry.funding !== 0;
